<template><div><h1 id="adressaktualisierung-starten" tabindex="-1"><a class="header-anchor" href="#adressaktualisierung-starten"><span>Adressaktualisierung starten...</span></a></h1>
<p>Adressaktualisierung starten... — Export von Personen- und Adressdaten für die Aktualisierung mit einem Aktualisierungsdienst</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit Adressaktualisierung können Personendaten mit einem vordefinierten Aktualisierungsdienst aktualisiert werden. Für die Aktualisierung ist unter Umständen ein Abonnement/Account beim jeweiligen Anbieter notwendig. Der Abgleich von Fremdadressen ist bei einigen Aktualisierungsdiensten nicht vorgesehen. Folgende Aktualisierungsdienste werden zurzeit unterstützt:</p>
<table>
<thead>
<tr>
<th>Aktualisierungsdienst</th>
<th>Abgleich von Fremdadressen</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adresspflege Online</td>
<td>ja</td>
</tr>
<tr>
<td>Adresspflege über Webservice</td>
<td>nein</td>
</tr>
<tr>
<td>CRIF</td>
<td>nein</td>
</tr>
<tr>
<td>Matchmove</td>
<td>ja</td>
</tr>
<tr>
<td>Multisource</td>
<td>nein</td>
</tr>
</tbody>
</table>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Personen → Datenpflege → Adressaktualisierung → Adressaktualisierung starten...</p>
<h3 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h3>
<dl>
<dt>Job-ID</dt>
<dd>Eindeutige Nummer des Aktualisierungsjobs</dd>
<dt>Aktualisierungsdienst</dt>
<dd>Selektierter Aktualisierungsdienst</dd>
<dt>Adressstamm</dt>
<dd>Selektierter Adressstamm</dd>
<dt>Aktion</dt>
<dd>Export der Daten mit und ohne Übermittlung zum Aktualisierungsdienst-Server. Bei den Aktualisierungsdiensten &quot;Adresspflege über Webservice&quot; und &quot;CRIF&quot; besteht die Option die Daten zuerst ohne Übermittlung zu exportieren und erst in einem nächsten Schritt zu übermitteln. Dadurch hat man die Möglichkeit die Daten vor der Übermittlung zu prüfen und erst danach zu übermitteln.
<table>
<thead>
<tr>
<th>Aktion</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Daten exportieren (ohne Übermittlung)</td>
<td>Die Daten werden exportiert, aber noch nicht zum Aktualisierungsdienst-Server übermittelt.</td>
</tr>
<tr>
<td>Daten exportieren mit Adressabgleich (kostenpflichtig)</td>
<td>Die Daten werden exportiert und auch gleich zum Aktualisierungsdienst-Server für den Abgleich übermittelt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Filter</dt>
<dd>Selektierter Filter</dd>
</dl>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Personendaten</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Personendaten werden für den Abgleich aufbereitet und exportiert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.abgleichsresultatimportieren.html" title="Abgleichsresultat importieren...">Abgleichsresultat importieren...</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adressaktualisierung.html" title="Adressaktualisierung">Adressaktualisierung</RouteLink></p>
</div></template>


